import Currency from '../models/Currency'

const state = {
  currencies: []
}

const mutations = {
  'SET_CURRENCIES'(state, currencies) {
    state.currencies = currencies;
  },
}

const actions = {
    async set_currencies({commit}) {
        try {
            let currencies = await Currency.all(`sort=name%7Casc&page=1&per_page=999&filter=`)
            commit('SET_CURRENCIES', currencies.data)
            return currencies.data
        } catch (e) {
            return e
        }
    },
}

const getters = {
  currencies: state => {
    return state.currencies;
  },
  fiat_currencies: state => {
      return state.currencies.filter(currency => currency.is_fiat === true)
  },
  crypto_currencies: state => {
      return state.currencies.filter(currency => currency.is_fiat === false)
  },
  getCurrencyInfo: (state) => (acronym) => {
    let item = state.currencies.find(item => item.acronym === acronym)
    return item !== undefined ? item : null
  }
}

export default {
  state,
  mutations,
  actions,
  getters
};
